/* DROPKY: delivery details go to Shopify; the HostedButton processes payment. */
(() => {
  'use strict';
  if (window.DropkyHostedCheckout) {
    document.querySelectorAll('[data-dkc-root]').forEach(window.DropkyHostedCheckout.initialise);
    return;
  }
  let sdkPromise;
  let sdkClientId;
  const normalise = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
  const emailValid = value => value.length <= 200 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  function loadSdk(clientId) {
    if (!/^[A-Za-z0-9_-]{12,256}$/.test(clientId)) return Promise.reject(new Error('ID client PayPal invalid.'));
    if (sdkPromise) return sdkClientId === clientId ? sdkPromise : Promise.reject(new Error('ID-uri PayPal incompatibile.'));
    sdkClientId = clientId;
    sdkPromise = new Promise((resolve, reject) => {
      if (window.dropkyPayPalHosted?.HostedButtons) { resolve(window.dropkyPayPalHosted); return; }
      const script = document.createElement('script');
      const url = new URL('https://www.paypal.com/sdk/js');
      url.search = new URLSearchParams({ 'client-id': clientId, components: 'hosted-buttons', 'disable-funding': 'venmo', currency: 'EUR' });
      script.src = url.href;
      script.async = true;
      script.dataset.namespace = 'dropkyPayPalHosted';
      script.dataset.dkcPaypalSdk = 'true';
      const timer = setTimeout(() => { script.remove(); reject(new Error('PayPal nu a răspuns la timp.')); }, 25000);
      script.onload = () => {
        clearTimeout(timer);
        if (window.dropkyPayPalHosted?.HostedButtons) resolve(window.dropkyPayPalHosted);
        else reject(new Error('PayPal HostedButtons nu este disponibil.'));
      };
      script.onerror = () => { clearTimeout(timer); script.remove(); reject(new Error('Nu s-a încărcat PayPal.')); };
      document.head.appendChild(script);
    });
    return sdkPromise;
  }
  function initialise(root) {
    if (!root || root.dataset.dkcInitialised) return;
    root.dataset.dkcInitialised = 'true';
    const $ = selector => root.querySelector(selector);
    const setText = (selector, value) => { const node = $(selector); if (node) node.textContent = value; };
    let config;
    try { config = JSON.parse($('[data-dkc-config]').textContent); } catch { return; }
    const native = $('[data-dkc-native]');
    const loader = $('[data-dkc-loader]');
    const alertBox = $('[data-dkc-alert]');
    const form = $('form.dkc__form');
    const email = $('[data-dkc-delivery-email]');
    const platformSelect = $('[data-dkc-platform-select]');
    const contactResult = form.querySelector('[data-dkc-contact-result]');
    config.contactPosted = contactResult?.dataset.posted === 'true';
    config.contactErrors = contactResult?.dataset.errors === 'true';
    const continueButton = $('[data-dkc-continue]');
    const receipt = $('[data-dkc-receipt]');
    const gate = $('[data-dkc-gate]');
    const fields = $('[data-dkc-fields]');
    const params = new URL(location.href).searchParams;
    const abort = new AbortController();
    let cancelled = false;
    let observer;
    let paymentLayout;
    let nativeEmail;
    let nativeSelection;
    let receiptReady = false;
    let paymentReady = false;
    let pending;
    try { pending = JSON.parse(sessionStorage.getItem('dropky:pay:delivery') || 'null'); } catch {}
    root._dkcCleanup = () => { cancelled = true; abort.abort(); observer?.disconnect(); };
    function fail(message, detail) {
      if (cancelled) return;
      paymentReady = false;
      continueButton.disabled = true;
      native.hidden = true;
      loader.hidden = true;
      alertBox.hidden = false;
      setText('[data-dkc-alert-text]', message);
      setText('[data-dkc-admin-detail]', detail || '');
    }
    $('[data-dkc-summary-toggle]')?.addEventListener('click', event => {
      const summary = $('[data-dkc-summary]');
      const expanded = summary.dataset.expanded !== 'true';
      summary.dataset.expanded = String(expanded);
      event.currentTarget.setAttribute('aria-expanded', String(expanded));
      event.currentTarget.querySelector('span').textContent = expanded ? '−' : '+';
    }, { signal: abort.signal });
    $('[data-dkc-retry]').addEventListener('click', () => location.reload(), { signal: abort.signal });
    const offers = (config.offers || []).filter(offer => /^[a-zA-Z0-9][a-zA-Z0-9_-]*$/.test(offer.handle || '') && /^[A-Z0-9]{10,32}$/.test(offer.buttonId || '') && Array.isArray(offer.variants));
    if (!offers.length) {
      setText('[data-dkc-product-title]', 'Produs indisponibil');
      fail(config.noProductText, 'Produsul fc27-standard-edition trebuie să existe și să fie publicat în Online Store.');
      return;
    }
    let handle = (params.get('handle') || '').trim();
    let variantId = (params.get('variant') || '').trim();
    let platform = (params.get('platform') || '').trim();
    let requestedEdition = (params.get('edition') || '').trim();
    // Preserve the selection if Shopify returns from CAPTCHA without the original query.
    if (!handle && !variantId && (config.contactPosted || config.contactErrors) && pending && Date.now() - pending.time < 3600000) {
      handle = pending.handle;
      variantId = pending.variantId;
      platform = pending.platform;
      requestedEdition = pending.edition;
    }
    if ((handle && !variantId) || (variantId && !handle) || (variantId && !/^\d+$/.test(variantId)) || platform.length > 100 || requestedEdition.length > 100) {
      fail(config.unavailableText, 'Parametri incompleți sau invalizi.');
      setText('[data-dkc-product-title]', 'Selectează din nou produsul');
      return;
    }
    let candidates = handle ? offers.filter(offer => offer.handle === handle && String(offer.variantId || offer.primaryVariantId) === variantId && (!offer.platform || normalise(offer.platform) === normalise(platform))) : [offers[0]];
    const specific = candidates.filter(offer => offer.platform);
    if (specific.length) candidates = specific;
    if (candidates.length !== 1) {
      setText('[data-dkc-product-title]', requestedEdition || 'Plata acestei ediții nu este disponibilă');
      setText('[data-dkc-edition]', requestedEdition || '—');
      fail(config.unavailableText, 'Lipsește un buton PayPal propriu pentru produs/variantă/platformă sau există asocieri duplicate. Nu folosim butonul Standard pentru altă ediție.');
      return;
    }
    const offer = candidates[0];
    handle = offer.handle;
    variantId ||= String(offer.variantId || offer.primaryVariantId);
    platform ||= offer.platform || '';
    const variant = offer.variants.find(item => String(item.id) === variantId);
    if (!variant?.available) { fail(config.unavailableText, 'Varianta nu există sau nu este disponibilă.'); return; }
    const edition = offer.edition || (variant.title !== 'Default Title' ? variant.title : offer.title);
    if (requestedEdition && normalise(requestedEdition) !== normalise(edition)) { fail(config.unavailableText, 'Ediția nu corespunde butonului PayPal.'); return; }
    if (offer.platform && ![...platformSelect.options].some(option => option.value === offer.platform)) {
      platformSelect.add(new Option(offer.platform, offer.platform));
    }
    if (platform && ![...platformSelect.options].some(option => option.value === platform)) {
      fail(config.unavailableText, 'Platforma nu se află în lista platformelor acceptate.');
      return;
    }
    platformSelect.value = platform;
    if (offer.platform) {
      [...platformSelect.options].forEach(option => { option.disabled = option.value !== offer.platform; });
    }
    setText('[data-dkc-product-title]', offer.title);
    setText('[data-dkc-edition]', edition);
    $('[data-dkc-back]').href = offer.url || '/products/' + encodeURIComponent(handle);
    if (offer.image) {
      try {
        const coverUrl = new URL(offer.image, location.origin);
        if (['https:', 'http:'].includes(coverUrl.protocol)) {
          const cover = $('[data-dkc-cover]');
          cover.src = coverUrl.href;
          cover.alt = offer.title;
          cover.hidden = false;
          $('[data-dkc-cover-placeholder]').hidden = true;
          cover.addEventListener('error', () => { cover.hidden = true; $('[data-dkc-cover-placeholder]').hidden = false; }, { signal: abort.signal });
        }
      } catch {}
    }
    if ($('[data-dkc-store-price-row]')) {
      try {
        setText('[data-dkc-store-price]', new Intl.NumberFormat('ro-RO', { style: 'currency', currency: config.storeCurrency }).format(variant.price / 100));
        $('[data-dkc-store-price-row]').hidden = false;
      } catch {}
    }
    const recordMatches = pending && pending.handle === handle && pending.variantId === variantId && pending.edition === edition && pending.platform === platform && Date.now() - pending.time < 3600000;
    if (recordMatches && emailValid(pending.email || '')) email.value = pending.email;
    receiptReady = !!config.contactPosted && !config.contactErrors && !!platform;
    if (receiptReady && recordMatches) setText('[data-dkc-receipt-email]', pending.email);
    else if (receiptReady) setText('[data-dkc-receipt-email]', 'Folosește la plată aceeași adresă e-mail pe care ai trimis-o pentru livrare.');

    function updateSelection() {
      platform = platformSelect.value;
      setText('[data-dkc-platform]', platform);
      $('[data-dkc-platform-row]').hidden = !platform;
      $('[data-dkc-contact-product]').value = offer.title;
      $('[data-dkc-contact-edition]').value = edition;
      $('[data-dkc-contact-variant]').value = variantId;
      const returnUrl = new URL(location.pathname, location.origin);
      returnUrl.search = new URLSearchParams({ handle, variant: variantId, platform, edition, contact_posted: 'true' });
      // Retain a theme preview while validating an unpublished ZIP.
      if (params.get('preview_theme_id')) returnUrl.searchParams.set('preview_theme_id', params.get('preview_theme_id'));
      returnUrl.hash = form.id;
      let returnField = form.querySelector('[name="return_to"]');
      if (!returnField) { returnField = document.createElement('input'); returnField.type = 'hidden'; returnField.name = 'return_to'; form.appendChild(returnField); }
      returnField.value = returnUrl.pathname + returnUrl.search + returnUrl.hash;
      if (nativeEmail) { nativeEmail.value = email.value.trim(); nativeEmail.dispatchEvent(new Event('keyup', { bubbles: true })); }
      if (nativeSelection) { nativeSelection.value = edition + (platform ? ' · ' + platform : ''); nativeSelection.dispatchEvent(new Event('keyup', { bubbles: true })); }
    }
    function syncGate() {
      if (cancelled) return;
      fields.hidden = receiptReady;
      receipt.hidden = !receiptReady;
      gate.hidden = receiptReady;
      if (!paymentLayout) return;
      const locked = !receiptReady;
      paymentLayout.dataset.dkcLocked = String(locked);
      paymentLayout.setAttribute('aria-disabled', String(locked));
      paymentLayout.inert = locked;
      continueButton.disabled = !paymentReady;
    }
    email.addEventListener('input', updateSelection, { signal: abort.signal });
    platformSelect.addEventListener('change', () => { receiptReady = false; updateSelection(); syncGate(); }, { signal: abort.signal });
    $('[data-dkc-edit]').addEventListener('click', () => { receiptReady = false; syncGate(); email.focus(); }, { signal: abort.signal });
    form.addEventListener('submit', event => {
      email.value = email.value.trim();
      if (!paymentReady || !emailValid(email.value) || !platformSelect.value || !form.reportValidity()) {
        event.preventDefault();
        if (!emailValid(email.value)) { email.setCustomValidity(config.emailError); email.reportValidity(); email.setCustomValidity(''); }
        return;
      }
      updateSelection();
      const reference = 'DK-' + Date.now().toString(36).toUpperCase() + '-' + Math.random().toString(36).slice(2, 7).toUpperCase();
      $('[data-dkc-contact-reference]').value = reference;
      const total = $('[data-dkc-total]').textContent.trim();
      $('[data-dkc-contact-body]').value = [
        'DROPKY - DATE PENTRU LIVRARE / SOLICITARE NEPLATITA',
        'Acest mesaj NU confirma o plata si NU este o comanda Shopify.',
        'Verificati separat tranzactia in PayPal inainte de livrarea cheii.',
        'E-mail livrare: ' + email.value, 'Produs: ' + offer.title,
        'Handle: ' + handle, 'Varianta Shopify: ' + variantId,
        'Editie: ' + edition, 'Platforma: ' + platform,
        'Cantitate: 1', 'Buton PayPal: ' + offer.buttonId,
        'Total afisat de PayPal: ' + total, 'Referinta solicitarii: ' + reference,
        'Clientul trebuie sa foloseasca aceeasi adresa de e-mail la plata.',
        'Aceasta referinta identifica formularul, nu tranzactia PayPal.'
      ].join('\n');
      try { sessionStorage.setItem('dropky:pay:delivery', JSON.stringify({ handle, variantId, edition, platform, email: email.value, reference, time: Date.now() })); } catch {}
      continueButton.setAttribute('aria-busy', 'true');
      // Submit normally: Shopify handles delivery of the notification, validation and CAPTCHA.
    }, { signal: abort.signal });
    updateSelection();
    syncGate();
    native.hidden = false;
    native.style.visibility = 'hidden';
    native.inert = true;
    loadSdk(config.clientId).then(sdk => {
      if (cancelled) return;
      return sdk.HostedButtons({ hostedButtonId: offer.buttonId }).render('#' + native.id);
    }).then(() => {
      if (cancelled) return;
      const container = native.querySelector('[id="paypal-form-fields-container-' + offer.buttonId + '"]');
      if (!container) throw new Error('Formularul PayPal nu s-a afișat.');
      if (container.querySelector('[id="quantity"], [id="amount"], [id="variant-selector"], [id="variant-selector2"]')) {
        fail(config.unavailableText, 'Asocierea necesită un buton cu preț fix și cantitate 1, fără variante PayPal.');
        return;
      }
      paymentLayout = container.querySelector('.paypal-buttons-layout');
      if (!paymentLayout) throw new Error('Butoanele PayPal lipsesc.');
      for (const name of ['memo', 'memo2']) {
        const field = container.querySelector('[id="' + name + '"]');
        const label = container.querySelector('[id="' + name + '-label"]');
        const labelText = label?.dataset.text || label?.textContent;
        if (field && normalise(labelText) === normalise(config.emailLabel)) nativeEmail = field;
        if (field && normalise(labelText) === normalise(config.selectionLabel)) nativeSelection = field;
      }
      if (nativeEmail && email.value) { nativeEmail.readOnly = true; nativeEmail.dataset.dkcEmail = 'true'; }
      if (nativeSelection) { nativeSelection.readOnly = true; nativeSelection.dataset.dkcSelection = 'true'; }
      updateSelection();
      const cardButton = container.querySelector('[id="checkout-button"]');
      if (cardButton) cardButton.textContent = config.cardButtonText || 'Plătește cu cardul';
      const cardArt = container.querySelector('.paypal-card-art');
      if (cardArt) {
        cardArt.alt = 'Carduri acceptate prin PayPal';
        cardArt.addEventListener('error', () => { cardArt.hidden = true; }, { signal: abort.signal });
      }
      container.querySelector('form')?.addEventListener('submit', event => {
        if (!receiptReady) { event.preventDefault(); event.stopImmediatePropagation(); email.focus(); }
      }, { capture: true, signal: abort.signal });
      function updateAmount() {
        const discount = container.querySelector('[id="discount-price"]');
        const amount = discount && getComputedStyle(discount).display !== 'none' ? discount : container.querySelector('[id="price-text"]');
        const value = amount?.textContent.trim();
        if (!value || !/EUR|€/.test(value)) { fail(config.unavailableText, 'Moneda și suma butonului PayPal trebuie să fie în EUR.'); return false; }
        setText('[data-dkc-total]', value);
        return true;
      }
      if (!updateAmount()) return;
      paymentReady = true;
      native.style.visibility = '';
      native.inert = false;
      loader.hidden = true;
      syncGate();
      observer = new MutationObserver(() => { updateAmount(); syncGate(); });
      const priceLabel = container.querySelector('[id="price-label"]');
      if (priceLabel) observer.observe(priceLabel, { childList: true, characterData: true, subtree: true });
      observer.observe(paymentLayout, { childList: true, subtree: true });
    }).catch(error => fail(config.loadError, error?.message || 'PayPal nu s-a încărcat.'));
  }
  window.DropkyHostedCheckout = { initialise };
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-dkc-root]').forEach(initialise));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-dkc-root]').forEach(root => root._dkcCleanup?.()));
  document.querySelectorAll('[data-dkc-root]').forEach(initialise);
})();
